<template>
  <!-- 店铺钱包 -->
  <section class="viewContainer">
    <div class="main_container">
      <div class="twoflex">
        <p>
          <b style="font-size: 20px;margin-right: 100px;">基本账户：
            <span style="color: #F56C6C;">
              {{ accumulate && accumulate.length > 0 ? accumulate[0].balance : '' }}
            </span> 元
          </b>
          <b style="font-size: 20px;">运营账户：
            <span style="color: #F56C6C;">
              {{ accumulate && accumulate.length > 1 ? accumulate[1].balance : '' }}
            </span> 元
          </b>
        </p>
      </div>
      <div class="fourflex">
        <div style="font-size: 14px;">注：基本账户到运营账户为转入，运营账户到基本账户为转出</div>
        <div v-show="iscityadmin == 0">
          <el-button type="primary" @click="handlecztx(1)">转入</el-button>
          <el-button type="danger" @click="handlecztx(2)">转出</el-button>
        </div>
      </div>
    </div>
    <div class="main_container">
      <!-- <p style="margin-left: 15px;"><b>{{threetitle}}列表</b></p> -->
      <el-radio-group v-model="zdmxczjltxjl" @change="handleClickthree" style="margin: 10px 0 10px 10px;">
        <el-radio-button :label="0">基本账户</el-radio-button>
        <el-radio-button :label="1">运营账户</el-radio-button>
      </el-radio-group>
      <div class="table_container">
        <!--  @selection-change="handleSelectionChange" -->
        <el-table :data="threelist" stripe border>
          <!-- <el-table-column type="selection" align="center"/> -->
          <el-table-column label="序号" align="center" width="60">
            <template scope="scope"> <span>{{ scope.$index + 1 }}</span> </template>
          </el-table-column>
          <el-table-column prop="trade_type_name" label="交易类型" align="center" />
          <el-table-column prop="trade_name" label="商家名称" align="center" />
          <el-table-column label="交易金额" align="center">
            <template scope="scope">￥{{ scope.row.trade_price }}</template>
          </el-table-column>
          <el-table-column label="当前余额" align="center">
            <template scope="scope">￥{{ scope.row.current_price }}</template>
          </el-table-column>
          <el-table-column label="备注" align="center">
            <template scope="scope"><span class="spanList">{{ scope.row.remark }}</span></template>
          </el-table-column>
          <el-table-column prop="created_time" label="交易时间" align="center" />
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :current-page="pageIndex"
          :page-size="10" :total="total" style="float:right;margin:10px 0;" />
      </div>
    </div>

    <!-- 转入&转出-弹框 -->
    <el-dialog :title="cztxtitle" :visible.sync="dialogcztx" :center="true" width="45%" append-to-body>
      <el-form style="padding-bottom: 20px;">
        <template v-if="cztxtitle == '转入'">
          <el-form-item label="转入金额：">
            <el-input v-model="inputAmount" placeholder="请输入要转入的金额"
              maxlength="8" style="width:70%;" @input="onInput"
              onkeyup="this.value=this.value.replace(/[^\d.]|^0+(?!$)/g,'')">
              <i slot="prefix" style="margin-left: 10px;">¥</i>
            </el-input>
            <br>
          </el-form-item>
          <el-table :data="tradelist" ref="multipleTable" stripe border @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center" />
            <el-table-column label="编码" align="center" width="60">
              <template scope="scope"> <span>{{ scope.row.notice_id }}</span> </template>
            </el-table-column>
            <el-table-column prop="shop_name" label="商家名称" align="center" width="200" />
            <el-table-column label="充值金额" align="center">
              <template scope="scope">￥{{ scope.row.total_price }}</template>
            </el-table-column>
            <el-table-column label="到账金额" align="center">
              <template scope="scope">￥{{ scope.row.price }}</template>
            </el-table-column>
            <el-table-column prop="recharge_time" label="充值时间" align="center" />
          </el-table>
        </template>
        <template v-else>
          <el-form-item label="转出金额：">
            <el-input v-model="inputAmount" placeholder="请输入要转出的金额"
              maxlength="8" style="width:70%;" @input="onInput"
              onkeyup="this.value=this.value.replace(/[^\d.]|^0+(?!$)/g,'')">
              <i slot="prefix" style="margin-left: 10px;">¥</i>
            </el-input>
          </el-form-item>
          <el-table :data="tradelist" ref="multipleTable" stripe border @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center" />
            <el-table-column label="编码" align="center" width="60">
              <template scope="scope"> <span>{{ scope.row.notice_id }}</span> </template>
            </el-table-column>
            <el-table-column prop="shop_name" label="商家名称" align="center" width="200" />
            <el-table-column label="金额" align="center">
              <template scope="scope">￥{{ scope.row.price }}</template>
            </el-table-column>
            <el-table-column prop="withdraw_time" label="提现时间" align="center" />
          </el-table>
        </template>
      </el-form>
      <div style="text-align:center">
        <el-button @click="cencalFun">取消</el-button>
        <el-button type="danger" @click="fixFh(1)" v-if="cztxtitle == '转入'">确定</el-button>
        <el-button type="danger" @click="fixFh(2)" v-else>确定</el-button>
      </div>
    </el-dialog>

    <!-- 微信扫码支付 -->
    <el-dialog title="微信扫码支付" :visible.sync="wxsmzfVisible" width="20%" center @close="closeWxsmzf">
      <div style="width: 90%; margin: 0 auto; text-align: center;">
        <div><b style="font-size: 26px;">{{ wxsmzfJine }} 元</b></div>
        <!-- <div style="color: #ccc;">（含6‰手续费）</div> -->
        <img :src="wxSmzfImg" style="width: 200px;" />
      </div>
    </el-dialog>
    

  </section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { userIdentity, postPlaceOrderNative, } from '../../api/newOss';
import {
  vmaccountgetdetail, vmaccountgetbalance, vmaccountisrecharge,
  vmaccountwithdraw, setpayee
} from "../../api/shopWindow";
import { tradeaccountgetlist, tradedetailgetlist, noticegetlist, transfer } from "../../api/shopWindow";
export default {
  name: 'vmacount', // 店铺钱包
  mixins: [alertTrends],
  data() {
    return {

      bbid: '',  //店铺id

      timer: null, // 轮询
      wxsmzfVisible: false, // 微信扫码支付
      wxsmzfJine: '', // 金额
      wxSmzfImg: '', // 二维码

      accumulate: [],// 累计
      zdmxczjltxjl: 0, // 账单明细&充值记录&提现记录
      threetitle: '基本账户',
      threelist: [],
      pageIndex: 1, // 当前页
      total: 0, // 总条数

      dialogcztx: false, // 转入 & 转出
      cztxtitle: '转入', // 标题


      iscityadmin: localStorage.iscityadmin, // 是否是城市管理员(城市分公司) 0=否 1=是


      accountid: [],  //账户ID
      tradelist: [],
      selectedArr: [], // 复选框选中项
      isSelecting: false,  // 是否有选中的复选框
      inputAmount: '', // 转入、转出金额
      allowManualInput: false,  // 是否允许手动输入
      tableInitialized: false, // 跟踪表格初始化状态

    };
  },
  computed: {
    // sjdzje() {
    //   let thiszhcz = this.zhcz * 0.994;
    //   return (Math.floor(thiszhcz * 100) / 100);
    // },

  },
  methods: {
    // 账单明细&充值记录&提现记录 - 切换tab
    handleClickthree(val) {
      // if (!this.bbid) {
      //   this.showAlert('请重新打开本功能，并选择一家店铺');
      //   return false;
      // }
      this.getthree();
      if (val == 0) {
        this.threetitle = '基本账户';
      } else if (val == 1) {
        this.threetitle = '运营账户';
      }
    },
    getthree() {
      let obj = {
        account_type: 0,
      };
      tradeaccountgetlist(obj, 3, this.bbid).then(data => {
        this.accumulate = data.resultObj; // 累计
        this.accountid = [this.accumulate[0].accountid, this.accumulate[1].accountid];
        this.pageIndex = 1;
        this.init();
      });
    },
    // 基本账户&运营账户
    init() {
      let accountid = this.zdmxczjltxjl == 0 ? this.accountid[0] : this.accountid[1];
      let obj = {
        pageindex: this.pageIndex,
        pagesize: 10
      };
      tradedetailgetlist(obj, accountid).then(data => {
        if (data.resultCode == 1) {
          this.threelist = data.resultObj.list;
          this.total = data.resultObj.totalcount;
        } else {
          this.threelist = [];
          this.total = 0;
        }
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    },
    // 充值提现
    handlecztx(type) {
      // if (!this.bbid) {
      //   this.showAlert('请重新打开本功能，并选择一家店铺');
      //   return false;
      // }
      this.dialogcztx = true;
      if (type == 1) {
        this.cztxtitle = '转入';
        this.inputAmount = '';
        this.noticegetlistFun(1);
      } else {
        this.cztxtitle = '转出';
        this.inputAmount = '';
        this.noticegetlistFun(2);
      }
    },
    noticegetlistFun(type) {
      let obj = {
        trade_type: type
      };
      noticegetlist(obj).then(data => {
        if (data.resultCode == 1) {
          this.tradelist = [];
          data.resultObj.forEach(element => {
            if (element) {
              this.tradelist.push(element)
            }
          });
          // this.tradelist = data.resultObj;
        } else {
          this.tradelist = [];
        }
      });
    },
    // 转入&转出 - 确定操作按钮
    fixFh(type) {
      if (this.inputAmount == '') {
        this.showAlert('金额不能为空');
        return;
      }
      if(this.tradelist.length>0&&this.selectedArr.length<1){
        this.showAlert('请勾选对应短信以便服务处理后续逻辑');
        return;
      }
      console.log(this.accountid,'???')
      let obj = {
        incomeaccountid: type==1?this.accountid[1]:this.accountid[0],       //入账账户ID
        incomeaccounttype: type==1?2:1,     //入账账户类型 1=基本账户 2=运营账户
        outcomeaccountid: type==1?this.accountid[0]:this.accountid[1],      //出账账户ID
        outcomeaccounttype: type==1?1:2,    //出账账户类型 1=基本账户 2=运营账户
        price: this.inputAmount,                 //转账金额
        noticeids: this.selectedArr,        //交易提醒ID
      };
      transfer(obj).then(data => {
        if (data.resultCode == 1) {
          this.showAlert(`${type==1?'转入':'转出'}成功`, 'success');
          this.getthree()
        } else if (data.resultCode == 4) {
          this.showAlert(`${type==1?'转入':'转出'}成功`, 'success');
          this.getthree();
        }
      });
      this.dialogcztx = false;
    },
    // 处理表格选择变化
    handleSelectionChange(selection) {
      this.selectedArr = '';
      this.selectedArr = selection.map(item => item.notice_id).join(',');

      this.isSelecting = selection.length > 0

      // 根据是否有选中项处理输入框
      if (this.isSelecting) {
        // 计算选中项的总金额并格式化
        this.inputAmount = selection.reduce((sum, item) =>
          sum + parseFloat(item.price || 0), 0
        ).toFixed(2);
      } else {
        // 取消全部勾选时清空输入框
        this.inputAmount = '';
      }
    },
    cencalFun() {
      this.dialogcztx = false;
      // 取消全部勾选时清空输入框
      this.inputAmount = '';
      this.clearSelections();
    },

    // 清空选中项
    clearSelections() {
      if (this.isSelecting) {
        this.$nextTick(() => {
          if (this.$refs.multipleTable) {
            this.$refs.multipleTable.clearSelection()
            this.isSelecting = false
            this.inputAmount = ''
          }
        })
      }

      this.allowManualInput = true
    },

    // 输入处理
    onInput(value) {
      // this.$nextTick(() => {
      //   if (this.$refs.multipleTable) {
      //     this.$refs.multipleTable.clearSelection()
      //     this.isSelecting = false
      //   }
      // })
      // 格式化输入值
      this.inputAmount = value.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.')
        .replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
        .replace(/^(\d+)\.(\d{2}).*$/, '$1.$2')

      // if (value && this.isSelecting) {
      //   setTimeout(() => {
      //     this.safeClearSelection()
      //     this.isSelecting = false
      //   }, 0)
      // }
    },
    // 安全清除选择的方法
    safeClearSelection() {
      // 使用可选链和条件检查确保安全调用
      if (this.$refs.multipleTable) {
        try {
          this.$refs.multipleTable.clearSelection()
        } catch (error) {
          console.error('清除表格选择失败:', error)
        }
      }
    },
    // 二维码弹框-关闭
    closeWxsmzf() {
      this.wxsmzfVisible = false; // 二维码弹窗消失
      clearTimeout(this.timer)
    },
  },
  mounted() {
    // this.bbid = this.$route.query.shopid; // 店铺id
    // this.loadWechatSDK(); // 加载微信 JS-SDK

    this.getthree();
    this.$nextTick(() => {
      this.tableInitialized = true
    })
  },
};
</script>

<style scoped>
.twoflex {
  display: flex;
  justify-content: space-between;
  margin: 0 15px 0 20px;
}

.fourflex {
  display: flex;
  justify-content: space-between;
  margin: 0 20px 10px 20px;
}

.fourflex div {
  font-size: 16px;
  margin-top: 10px;
}

/* 元素占位 */
.divhide {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// vxaccount.vue?c511e84a